// extracted by mini-css-extract-plugin
export default {"footer-buttons":"UfEOWX"};